import { makeStyles } from '@material-ui/styles'

const styles = makeStyles((theme) => ({
  container: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    backgroundColor: theme.palette.primary.hover,
    color: theme.palette.common.white,
    paddingBlock: theme.spacing(1),
    paddingInline: theme.spacing(2),
    gap: theme.spacing(2),
    borderRadius: 4,
    width: '100%',
  },
  content: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(2),
  },
  link: {
    cursor: 'pointer',
  },
}))

export default styles
